<template>
		<div class="home-page">
    <div class="header-bgfff bgfff">
      <Header></Header>
      <div class="nav ac">
        <div class="back" @click="back" >
          <img width="80" src="../../static/images/back2.png" />
        </div>

        <div class="nav-t"><span>{{$t('Basic Chinese Challenge')}}</span></div>
      </div>
    </div>
			<div class="home-content ac">
        <h2 class="font-family mt30">{{$t('Your Result')}}</h2>
        <div class="mt10">
          <img v-if="info.total_star==1" style="width: 80px;" src="../../static/images/Star.png">
          <div class="" v-if="info.total_star==2">
            <img style="width: 80px;" src="../../static/images/Star.png">
            <img style="width: 80px;" src="../../static/images/Star.png">
          </div>
          <div class=""  v-if="info.total_star==3">
            <img style="width: 80px;" src="../../static/images/Star.png">
            <img style="width: 80px;" src="../../static/images/Star.png">
            <img style="width: 80px;" src="../../static/images/Star.png">
          </div>
        </div>
        <div class="info">
            <div class="result-t mt30 result-title disflex">
              <div class="t">{{$t('Ques No')}}</div>
              <div class="t">{{$t('Correct Answer')}}</div>
              <div class="t">{{$t('Your Answer')}}</div>
              <div class="t">{{$t('Final Result')}}</div>
            </div>
          <div class="result-content">
            <div class="result-list crfff">
              <div class="result-t disflex" v-for="(item,index) in info.result">
                <div class="">{{item.question_id}}</div>
                <div class="">{{item.rightAnswer}}</div>
                <div class="">{{item.yourAnswer}}</div>
                <div class="red">
                  <img v-if="item.right" src="../../static/images/dui.png">
                  <img v-else src="../../static/images/cuo.png">
                </div>
              </div>
            </div>
          </div>

          <footer class="navigation disflex mt50">
            <button
              class="button pre-button font-family"
              @click="Previous"
            >{{$t('Try Again')}}</button>
            <button
              class="button next-button font-family"
              @click="Next"
            >{{$t('Next Level')}}</button>
          </footer>
        </div>
			</div>
		</div>
</template>
<script>
import Header from '../components/HeaderOne'
import Dialog from '../components/dialog'
export default {
    components:{
		Header,
    Dialog
    },
    data() {
      return {
       isShow:null,
       info:{},
       redeemInfo:{},
        gameList:null
      }
    },
	created(){
    this.getList()
	},
  methods: {
		back(){
			this.$router.push({path:'/Challenge',query: {}});
		},
    Previous(){
      this.$router.push({path:'/ChallengeLearn',query:{id:this.$route.query.id}});
    },
    Next(){
      this.$router.push({path:'/ChallengeLearn',query:{id:this.info.nex_task_id}});
    },
    getList(){
      let that = this
      let data = {
        'task_id':this.$route.query.id
      }
      that.$parent.loadModal(true);
      that.$api.post('/api/task/get_task_result',data,r =>{
        that.$parent.returnCode(r,function(){
          that.info = r.data
          that.$parent.loadModal(false);
        })
      })
    },
    goBattleRoom(item){
       this.$router.push({path:'/ChallengeLearn',query:{id:item}});
    },
	}
}
</script>
<style>
.empty-message {
  padding: 100px 0;
  font-size: 24px;
  color: #999;
}
</style>



// WEBPACK FOOTER //
// src/page/ChallengeResult.vue